import { render, staticRenderFns } from "./FormCatalogoProducto.vue?vue&type=template&id=41812eea&"
import script from "./FormCatalogoProducto.vue?vue&type=script&lang=js&"
export * from "./FormCatalogoProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports